import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import logoFooter from '../../utils/assets/images/logo-aps-benin-details-white.png'

const Footer = () => (
  <div>
    {/*Footer on Web */}
    <div className="aps-footer-show-web">
      <div className="uk-container-large aps-container-large">
        <div className="aps-footer">
          <div className="uk-child-width-1-1 uk-grid-divider aps-footer-container uk-text-center" data-uk-grid>
            <div className="aps-footer-column-first">
              <img className="aps-footer-logo" src={logoFooter} alt="logo" />
            </div>
          </div>
          <div className="aps-footer-copyright">
            <div className="uk-text-center aps-footer-copyright-title">
              Suivez-nous sur les réseaux sociaux
              <span className="aps-footer-copyright-social-network">
                <Link to="https://www.facebook.com/APS.Benin.Officiel" target="_blank"><i className="uk-text-center fa fa-facebook aps-footer-social-network"></i></Link>
                <Link to="https://twitter.com/ApsBenin" target="_blank"><i className="uk-text-center fa fa-twitter aps-footer-social-network"></i></Link>
                {/*
                <Link to="www.google-plus.com/aps-benin" target="_blank"><i className="uk-text-center fa fa-google-plus aps-footer-social-network"></i></Link>
                */}
              </span>
              © 2017 APS - Bénin - Tous droits réservés
            </div>
          </div>
        </div>
      </div>
    </div>
    {/*Footer on Mobile*/}
    <div style={{display:"none"}} className="aps-footer-show-mobile">
      <div className="aps-footer">
        <div className="uk-text-center">
          <img className="aps-footer-logo" src={logoFooter} alt="logo" />
        </div>
        <div className="aps-footer-copyright-mobile">
          <div className="uk-text-center aps-footer-copyright-title-one">
            Suivez-nous sur les réseaux sociaux
          </div>
           <div className="uk-text-center aps-footer-copyright-social-network">
            <Link to="https://www.facebook.com/APS.Benin.Officiel" target="_blank"><i className="uk-text-center fa fa-facebook aps-footer-social-network"></i></Link>
            <Link to="https://twitter.com/ApsBenin" target="_blank"><i className="uk-text-center fa fa-twitter aps-footer-social-network"></i></Link>
            {/*
              <Link to="www.google-plus.com/aps-benin" target="_blank"><i className="uk-text-center fa fa-google-plus aps-footer-social-network"></i></Link>
              */}
          </div>
          <div className="uk-text-center aps-footer-copyright-title-two">
            © 2017 APS - Bénin - Tous droits réservés
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js